/**
 * PROXY 동의 모드 (PROXY_ADMIN EMAIL_LINK / UNIQUE_URL / PARENT_PROXY + PROXY_FAMILY) API.
 * 백엔드: STS ProxyConsentApiController / AccountConsentApiController.
 */
import api from './index';

export const proxyConsentApi = {
    /**
     * 토큰 메타 조회 — 페이지 진입 시 만료/취소 확인.
     * @param {string} token
     * @returns {Promise<{ success, data: { csrId, consentMode, rpId, expiresAt, recipientEmail, hasParentUserId } }>}
     */
    validateToken(token) {
        return api.get(`/api/consent/validate/${encodeURIComponent(token)}`);
    },

    /**
     * EMAIL_LINK / UNIQUE_URL — 본인 canvas 서명 제출.
     * @param {string} token
     * @param {{ signatureBase64: string, signerName: string }} req
     */
    sign(token, req) {
        return api.post(`/api/consent/sign/${encodeURIComponent(token)}`, req);
    },

    /**
     * PARENT_PROXY — 부모 동의 (서명 없음, 로그인 사실로 갈음).
     * 본 호출은 부모 STS 로그인 필요.
     * @param {string} token
     */
    parentApprove(token) {
        return api.post(`/api/consent/parent-approve/${encodeURIComponent(token)}`);
    },

    /**
     * 부모의 자녀 동의 대기열 (PARENT_PROXY status='PENDING').
     */
    getPendingParentConsents() {
        return api.get('/api/account/pending-parent-consents');
    },

    /**
     * PROXY_FAMILY 자녀 가입 신청.
     * @param {ChildRegisterDto} req
     */
    registerChild(req) {
        return api.post('/api/account/children/register', req);
    },

    /**
     * 내가 대리 등록 신청한 가족 목록.
     * @param {boolean} [includeInactive=false] — EXPIRED/CANCELLED 포함 여부.
     * @returns {Promise<{ data: { success, data: MyProxyRegistrationItemDto[] } }>}
     */
    getMyProxyRegistrations(includeInactive = false) {
        const params = includeInactive ? { includeInactive: true } : {};
        return api.get('/api/account/my-proxy-registrations', { params });
    },

    /**
     * 대리 등록 자격 사전 확인 (family-register-dept-relations Phase A2).
     *
     * @param {Object|('MINOR'|'ELDERLY')} [options] — object 형식 권장. 문자열 전달 시 legacy proxyType.
     *   - options.relation: 'CHILD'|'PARENT'|'OTHER'|'GUARDIAN' (신규 우선, 관계별 정책 조회)
     *   - options.proxyType: 'MINOR'|'ELDERLY' (relation 없을 때만 back-map)
     * @returns {Promise<{ data: { success, data: { eligible, reason, relation, proxyType } } }>}
     */
    checkChildRegisterEligibility(options) {
        let params = {};
        if (typeof options === 'string') {
            // legacy — proxyType 문자열
            params = { proxyType: options };
        } else if (options && typeof options === 'object') {
            if (options.relation) params.relation = options.relation;
            if (options.proxyType) params.proxyType = options.proxyType;
        }
        return api.get('/api/account/children/register-eligibility', { params });
    },
};
